import { CheckCircle2, XCircle, Clock } from "lucide-react";

const OK = { Icon: CheckCircle2, cls: "border-emerald-500/30 bg-emerald-500/10 text-emerald-300" };
const STYLE = {
  sent: OK, simulated: OK,
  queued: { Icon: Clock, cls: "border-amber-500/30 bg-amber-500/10 text-amber-300" },
};
const FAILED = { Icon: XCircle, cls: "border-red-500/30 bg-red-500/10 text-red-300" };
const LABEL = { sent: "Spoki ha accettato l'invio", simulated: "Simulato (modalità mock)", queued: "In coda (fascia notturna)", skipped: "Non inviato", failed: "Rifiutato da Spoki" };

export function TestResult({ r }) {
  if (!r) return null;
  const ok = r.status === "sent" || r.status === "simulated";
  const { Icon, cls } = STYLE[r.status] || FAILED;
  const label = LABEL[r.status] || r.status;
  return (
    <div className={`rounded-md border p-2 text-[11px] space-y-1 ${cls}`} data-testid={`whatsapp-test-result-${r.outcome}`}>
      <div className="flex items-center gap-1.5 font-semibold"><Icon className="h-3.5 w-3.5" /> {label}{r.http_status ? ` · HTTP ${r.http_status}` : ""}</div>
      {r.error && <div className="font-mono-code break-all">{String(r.error).slice(0, 300)}</div>}
      {r.template_id && <div className="text-muted-foreground break-all">via {String(r.template_id)}</div>}
      {r.preview && <div className="text-foreground/80 whitespace-pre-wrap">{r.preview}</div>}
    </div>
  );
}
